import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup } from '@angular/forms';

import { startWith } from 'rxjs/operators';

import { TellentAppsDataFacade } from '@core/tellent-logic';
import { SeatKind, SeatType, TellentRole } from '@core/tellent-types';

@Injectable({ providedIn: 'root' })
export class AccessRolesTableService {
  private readonly apps = inject(TellentAppsDataFacade);
  private readonly destroyRef = inject(DestroyRef);

  public bindSeatLogic(seatKind: SeatKind, seatFormGroup: FormGroup<SeatType>) {
    const toggleCtrl = seatFormGroup.controls.toggle;
    const roleCtrl = seatFormGroup.controls.roleExternalId;

    toggleCtrl.valueChanges
      .pipe(startWith(toggleCtrl.value), takeUntilDestroyed(this.destroyRef))
      .subscribe(isOn => {
        const defaultRole: TellentRole | null = this.apps.defaultRoleBySeatKind(seatKind)() ?? null;

        if (!isOn) {
          // OFF → clear & disable
          roleCtrl.setValue(null, { emitEvent: false });
          roleCtrl.disable({ emitEvent: false });
        } else if (isOn) {
          // ON  → enable & maybe seed default
          roleCtrl.enable({ emitEvent: false });
          if (!roleCtrl.value && defaultRole?.externalId) {
            roleCtrl.setValue(defaultRole.externalId, { emitEvent: false });
          }
        }
      });
  }
}
